import { Injectable } from '@angular/core';

@Injectable()
export class FilePreviewService {
  applyPreviewImage(files: any[]) {
    files.forEach(x => {
      x.previewImage = this._getPreviewImage(this.decodeBase64(x.data), x.extension);
      x.file = this._getFile(this.decodeBase64(x.data), x.extension, x.id + '.' + x.extension, x.mimeType);
    });
  }

  private _getFile(fileData: Uint8Array, extension: string, fileName: string, mimeType: string) {
    const blob = this._getBlob(fileData, extension);
    const file = new File([blob], fileName, { lastModified: new Date().getTime(), type: mimeType });
    return file;
  }

  private _getPreviewImage(fileData: Uint8Array, extension: string): string {
    switch (extension) {
      case 'png':
      case 'jpeg':
        return this.displayImage(fileData, extension);
      case 'jpg':
      case 'jfif':
        return this.displayImage(fileData, 'jpeg');
      case 'doc':
      case 'docx':
        return '../../../../assets/icons/file_ext/ext_word.svg';
      case 'pdf':
        return '../../../../assets/icons/file_ext/ext_pdf.svg';
      case 'xlsx':
        return '../../../../assets/icons/file_ext/ext_excel.svg';
      default:
        return '../../../../assets/icons/component_icons/not-image-main-icon.png';
    }
  }

  private _getBlob(data: Uint8Array, extension: string) {
    switch (extension) {
      case 'pdf':
        return new Blob([data as BlobPart], { type: 'application/pdf' });
      case 'jpg':
      case 'jfif':
        return new Blob([data as BlobPart], { type: 'image/jpeg' });
      case 'jpeg':
      case 'png':
        return new Blob([data as BlobPart], { type: 'image/' + extension });
      case 'doc':
        return new Blob([data as BlobPart], { type: 'application/msword' });
      case 'docx':
        return new Blob([data as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      case 'xlsx':
        return new Blob([data as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      default:
        null;
    }
  }

  private decodeBase64(base64String: string): Uint8Array {
    const binaryString = window.atob(base64String);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  private displayImage(fileBytes: Uint8Array, extension: string): string {
    const blob = this._getBlob(fileBytes, extension);
    const imageUrl = URL.createObjectURL(blob);
    return imageUrl;
  }
}
